import React from "react";
import { useApp } from "@/context/AppContext";
import { MemberCard } from "@/components/MemberCard";

export default function MyCard() {
  const { user, t } = useApp();
  return (
    <div className="px-6 pt-8 fade-up">
      <h1 className="font-serif-cu text-2xl text-center mb-2">{t("my_card")}</h1>
      <p className="eyebrow text-center mb-8">Caught Up International</p>
      <MemberCard member={user} />
    </div>
  );
}
